import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import IntegrationUserSync from '../IntegrationUserSync';

const autoImportContent = (
  <div style={{ width: 500 }}>
    Ontraccr can automatically import Employees from Sage Intacct.
    <br />
    <br />
    1. Make sure the Employees in Sage Intacct have their email set.
    <br />
    <br />
    2. We will automatically set their Ontraccr username
    and password when importing and send this information to their email.
    <br />
    <br />
    3. All users will be assigned the &apos;Worker&apos;
    role after importing, make sure you change each user&apos;s role afterwards as needed.
    <br />
    <br />
    If you would rather see exactly which
    data will be imported from Sage Intacct
    and fill in any missing fields, disable Auto Import to do this manually.
  </div>
);

const importHelpText = (
  <div style={{ width: 500 }}>
    Select from this dropdown to either
    {' '}
    <b>Import</b>
    {' '}
    new Employees from Sage Intacct
    or
    {' '}
    <b>Link</b>
    {' '}
    Sage Intacct Employees to existing Ontraccr Users
    <br />
    <br />
    {' '}
    <b>Import:</b>
    {' '}
    Employees must have an email to be imported into Ontraccr.
    <br />
    {' '}
    <b>Link:</b>
    {' '}
    Select an existing Ontraccr user to link with the Sage Intacct Employee.
  </div>
);

function SageIntacctEmployeeSync({
  sageIntacctEmployees = [],
  onEmployeesChanged,
  importEmployees,
  divisionFilter,
}) {
  const users = useSelector((state) => state.users.users);
  const positions = useSelector((state) => state.settings.positions);
  return (
    <IntegrationUserSync
      title="Sage Intacct"
      integrationUsers={sageIntacctEmployees}
      integrationKey="sageId"
      users={users}
      positions={positions}
      onUsersChanged={onEmployeesChanged}
      autoImportContent={autoImportContent}
      importHelpText={importHelpText}
      importUsers={importEmployees}
      divisionFilter={divisionFilter}
    />
  );
}

/* eslint-disable  react/forbid-prop-types */
SageIntacctEmployeeSync.propTypes = {
  sageIntacctEmployees: PropTypes.array,
  onEmployeesChanged: PropTypes.func.isRequired,
  importEmployees: PropTypes.array,
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctEmployeeSync.defaultProps = {
  sageIntacctEmployees: [],
  importEmployees: [],
  divisionFilter: null,
};

export default SageIntacctEmployeeSync;

